
const getCountPlayer = (state) => state.countPlayer;

const getAffReport = (state) => state.affReport;

const getSelectedMonth = (state) => state.selectedMonth;
const getLoading = (state) => state.loading;
const getLoadingBar = (state) => state.loadingBar;
const getProgressBarValue = (state) => state.barValue;
const getListMonth = (state) => state.listMonth;
const getBarChartData = (state) => state.barChartData;
const getSelectedDefaultMonth = (state) => state.defaultSelectedMonth;
export default {
    getProgressBarValue,
    getLoadingBar,
    getBarChartData,
    getListMonth,
    getSelectedDefaultMonth,
    getCountPlayer,
    getAffReport,
    getSelectedMonth,
    getLoading
};
